import React from "react";
import {
  Search,
  Card,
  Treeview,
  SwitchToggle,
} from "../../../../CommonComponents";
import "./sidebar.scss";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const Sidebar = () => {
  const TreeviewData: any = [
    {
      id: 1,
      parent: 0,
      droppable: true,
      text: "Folder 1",
    },
    {
      id: 2,
      parent: 1,
      droppable: true,
      text: "File 1-1",
    },
    {
      id: 3,
      parent: 1,
      droppable: true,
      text: "File 1-2",
    },
    {
      id: 4,
      parent: 2,
      droppable: false,
      text: "File 1-1-1",
    },
    {
      id: 5,
      parent: 2,
      droppable: false,
      text: "File 1-1-2",
    },
    {
      id: 6,
      parent: 1,
      droppable: false,
      text: "Folder 2",
    },
    {
      id: 7,
      parent: 3,
      droppable: true,
      text: "File 1-2-1",
    },
    {
      id: 8,
      parent: 3,
      droppable: false,
      text: "File 1-2-2",
    },
    {
      id: 9,
      parent: 7,
      droppable: false,
      text: "File 1-2-1-1",
    },
  ];
  const ContextMenuData1: any = [
    {
      id: 1,
      text: "Add",
      dynamicClass: "bgBlue",
    },
    {
      id: 2,
      text: "Edit",
      dynamicClass: "bgBlue",
    },
    {
      id: 3,
      text: "Merge",
      dynamicClass: "bgBlue",
    },
  ];
  return (
    <div className="adminCardClass ">
        <Card data-attribute="sidebar_Default_Card">
          <div className="mb-1">
            <Search placeholder="Search Item" className="sidebarSearchTextbox"  data-attribute="sidebar_Default_Searchbox" />
          </div>
          <div className="adminSearch">
            <SwitchToggle defaultChecked={true}  data-attribute="sidebar_Default_SwitchToggle" />
            <p className="activeClass">Show active only</p>
          </div>       
          <div className="admintreeview"> 
            <DndProvider backend={HTML5Backend}>        
              <Treeview
                TreeviewData={TreeviewData}
                ContextMenuData1={ContextMenuData1}
               data-attribute="sidebar_Default_Treeview" />  
            </DndProvider>        
          </div>
        </Card>
    </div>
  );
};

export default Sidebar;
